export default __webpack_public_path__ + "static/media/mail.03e2f495.svg";